import React, { useCallback, useContext, useMemo } from 'react'
import SectionFormContainer from '../components/SectionFormContainer'
import BoardingWizardContext from './BoardingWizardContext'
import { Checkbox, makeStyles } from '@material-ui/core'
import { FONT_WEIGHTS, formatNumsToDollars } from '../../../utils'
import useBoardingVisit from '../../../hooks/useBoardingVisit'
import StyledAlert from '../../Common/StyledAlert'

const useStyles = makeStyles(() => ({
	root: { display: 'flex', flexDirection: 'column', flex: 1, width: '55%', gap: '2rem', alignItems: 'center' },
	subtextContainer: {
		textAlign: 'center',
		fontFamily: 'Nunito',
		fontSize: '0.875rem',
		fontWeight: FONT_WEIGHTS.SemiBold
	},
	formContainer: { display: 'flex', flex: 1, width: '80%', gap: '.75rem', marginTop: '1rem' },
	checkBoxContainer: {
		'& .MuiCheckbox-root': {
			padding: 0
		}
	},
	policyTextContainer: {
		fontFamily: 'Nunito',
		fontSize: '1rem',
		fontWeight: FONT_WEIGHTS.SemiBold
	}
}))

const DepositNotification = (props) => {
	const classes = useStyles()
	const {
		wizardContextProvider: { wizard_state, setWizardAttributeAndValues }
	} = useContext(BoardingWizardContext)
	const { attr, subtext = '', title = '' } = props
	const { boarding } = useBoardingVisit()

	const numberOfPets = useMemo(() => wizard_state['pets'].length, [wizard_state])

	const numberOfNights = useMemo(() => {
		const { dates } = wizard_state
		return dates.length - 1
	}, [wizard_state])

	const depositAmount = useMemo(() => {
		if (!boarding || !boarding.deposit_rate) {
			return 0
		}

		const { deposit_rate } = boarding
		const deposit = deposit_rate * numberOfNights * numberOfPets

		return deposit
	}, [boarding, numberOfNights, numberOfPets])

	const depositPaid = useMemo(() => {
		const { deposit_paid } = wizard_state
		return deposit_paid
	}, [wizard_state])

	const depositNotificationText = useMemo(() => {
		return `By checking this box, I understand that a holiday deposit of ${formatNumsToDollars(
			depositAmount
		)} is required for securing this appointment, which will be collected upon scheduling.`
	}, [depositAmount, wizard_state])

	const handleSelection = useCallback(
		(e) => {
			if (e.target && e.target.checked !== undefined) {
				const newValues = { ...wizard_state }
				newValues[attr] = e.target.checked
				setWizardAttributeAndValues(newValues)
			}
		},
		[wizard_state, setWizardAttributeAndValues, attr]
	)

	return (
		<SectionFormContainer title={title}>
			<div className={classes.root}>
				<div className={classes.subtextContainer}>{subtext}</div>
				<div className={classes.formContainer}>
					<div className={classes.checkBoxContainer}>
						<Checkbox onChange={handleSelection} checked={wizard_state[attr] === true} />
					</div>
					<div className={classes.policyTextContainer}>{depositNotificationText}</div>
				</div>
			</div>
			{depositPaid ? (
				<StyledAlert style={{ marginTop: '.8rem' }} type="warning" text="Deposit has already been paid." />
			) : null}
		</SectionFormContainer>
	)
}

export default DepositNotification
